// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"05932c09","240":"78ae0637","451":"32742cf4","730":"e98fbc4e","787":"2c13e94e","973":"3130cbf0"}[chunkId] + ".chunk.js";
};